import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Icon from '@material-ui/core/Icon';
import { withRouter } from "react-router";

class ErrorContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {

	    return (
			<p class="errormsg">
				Se ha producido un error procesando los documentos.<br/> Para mas información puede contactar con <a href="mailto:helpdesk@eclanguages.eu">helpdesk@eclanguages.eu</a>
			</p>
		);
	}
}

export default ErrorContainer;